import type { StorageType } from './internal/StorageType';
import { defaultStorageType } from './internal/StorageType';

export function getBrowserStorage(storageType: StorageType = defaultStorageType): Storage | undefined {
  try {
    return window[storageType];
  } catch {
    return undefined;
  }
}
